import React from "react";
import PropTypes from "prop-types";

import { Field, Label, Control, Input, Box, Title } from "rbx";

import { EditUserGroupMembershipForm } from "../UserGroupMemberships";
import {
  BooleanInput,
  CompanySelect,
  ConfirmPasswordInput,
  EmployeeSelect
} from "../inputs";

const UserForm = ({
  id,
  showUserGroupMembershipField,
  showPasswordInput,
  inputs,
  onChange,
  editing,
  FromEmployee
}) => (
  <div className="user-form-container">
    <div className="user-form-item">
      {showUserGroupMembershipField && <Title>User Details</Title>}
      <Box>
        <Field kind="group">
          <Control>
            <Label>{!FromEmployee ? "From Employee" : "From"}</Label>
            <BooleanInput
              name="FromEmployee"
              value={FromEmployee}
              onChange={onChange}
            />
          </Control>
          {FromEmployee && (
            <Control>
              <EmployeeSelect
                icon="user"
                label="Employee"
                name="EmployeeRecIdRef"
                readOnly={!editing}
                required={false}
                value={inputs.EmployeeRecIdRef}
                onChange={onChange}
              />
            </Control>
          )}
        </Field>
        <Field kind="group">
          <Control expanded>
            <Label>User Id</Label>
            <Input
              required
              autocomplete="new"
              name="UserId"
              readOnly={!editing}
              type="text"
              value={inputs.UserId}
              onChange={onChange}
              // disabled={FromEmployee && !newUser}
            />
          </Control>
          <Control expanded>
            <CompanySelect
              required
              icon="globe"
              label="Company"
              name="CompanyId"
              readOnly={!editing}
              value={inputs.CompanyId}
              onChange={onChange}
            />
          </Control>
          <Control>
            <Label>Active</Label>
            <BooleanInput
              name="Active"
              readOnly={!editing}
              value={inputs.Active}
              onChange={onChange}
            />
          </Control>
        </Field>
        <Field kind="group">
          <Control expanded>
            <Label>First Name</Label>
            <Input
              autocomplete="new"
              disabled={FromEmployee}
              name="FirstName"
              readOnly={!editing}
              type="text"
              value={inputs.FirstName}
              onChange={onChange}
            />
          </Control>
          <Control expanded>
            <Label>Middle Name</Label>
            <Input
              autocomplete="new"
              disabled={FromEmployee}
              name="MiddleName"
              readOnly={!editing}
              type="text"
              value={inputs.MiddleName}
              onChange={onChange}
            />
          </Control>
          <Control expanded>
            <Label>Last Name</Label>
            <Input
              autocomplete="new"
              disabled={FromEmployee}
              name="LastName"
              readOnly={!editing}
              type="text"
              value={inputs.LastName}
              onChange={onChange}
            />
          </Control>
        </Field>
        {showPasswordInput && (
          <ConfirmPasswordInput
            required
            password={inputs.Password}
            readOnly={!editing}
            onChange={onChange}
          />
        )}
      </Box>
    </div>
    {showUserGroupMembershipField && (
      <div className="user-form-item">
        <Title>Roles</Title>
        <Box>
          <EditUserGroupMembershipForm
            id={id}
            inputs={inputs}
            readOnly={!editing}
            onChange={onChange}
          />
        </Box>
      </div>
    )}
  </div>
);
UserForm.propTypes = {
  id: PropTypes.number,
  onChange: PropTypes.func,
  inputs: PropTypes.object,
  showUserGroupMembershipField: PropTypes.bool,
  showPasswordInput: PropTypes.bool,
  editing: PropTypes.bool,
  FromEmployee: PropTypes.bool
};
UserForm.defaultProps = {
  showUserGroupMembershipField: true,
  showPasswordInput: false
};
export default UserForm;
